import { EnvironmentConfig } from 'types';

export const API_BASEURL: EnvironmentConfig = {
  dev: 'https://api-dev1.headliner.link',
  prod: 'https://api.headliner.link',
};

export const AUDIO_PROXY_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://audio-proxy-service-dev1.sparemin.com',
  prod: 'https://audio-proxy-service.sparemin.com',
};

export const AUTHENTICATION_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://authentication-service-dev1.sparemin.com',
  prod: 'https://authentication-service.sparemin.com',
};

export const EMBED_CONFIGURATION_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://embed-configuration-service-dev1.sparemin.com',
  prod: 'https://embed-configuration-service.sparemin.com',
};

export const HEADLINER_USER_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://headliner-user-service-dev1.sparemin.com',
  prod: 'https://headliner-user-service.sparemin.com',
};

export const MEDIA_UPLOAD_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://media-upload-service-dev1.sparemin.com',
  prod: 'https://media-upload-service.sparemin.com',
};

export const MIXPANEL_PROXY_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://mp-service-dev1.headliner.app',
  prod: 'https://mp-service.headliner.app',
};

export const PLAN_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://plan-service-dev1.sparemin.com',
  prod: 'https://plan-service.sparemin.com',
};

export const PODCAST_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://podcast-service-dev1.sparemin.com',
  prod: 'https://podcast-service.sparemin.com',
};

export const THIRD_PARTY_AUTH_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://third-party-authentication-service-dev1.headliner.app',
  prod: 'https://third-party-authentication-service.headliner.app',
};

export const RECORDING_SERVICE_BASEURL: EnvironmentConfig = {
  dev: 'https://recording-service-dev1.sparemin.com',
  prod: 'https://recording-service.sparemin.com',
};
